import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import PlaylistByUrl from "./components/PlaylistByUrl";
import { selectPlaylists } from "../../store/slices/playlists";
import { useEffect } from "react";
import { playlistCards } from "../../api/asyncThuncks/playlistsCards";

const Playlist = () => {
  const dispatch = useAppDispatch();
  const { playlistByUrl } = useAppSelector(selectPlaylists);
  const { publicUrl } = useParams();

  useEffect(() => {
    if (publicUrl) {
      dispatch(playlistCards(publicUrl));
    }
  }, []);
  const stripHtml = (html?: string) => {
    return html ? html.replace(/<[^>]*>/g, "").trim() : "";
  };

  const seoDescription = playlistByUrl
    ? stripHtml(playlistByUrl.description).slice(0, 150)
    : "";

  return (
    <div className="px-4 py-5 w-screen bg-white max-w-[1000px] md:px-0">
      <>
        {playlistByUrl && (
          <Helmet>
            <title>{`Радіо «Сільпо» | ${playlistByUrl.title}`}</title>
            <meta name="title" content={`Радіо «Сільпо» | ${playlistByUrl.title}`} />
            <meta property="og:title" content={`Радіо «Сільпо» | ${playlistByUrl.title}`} />
            <meta name="twitter:title" content={`Радіо «Сільпо» | ${playlistByUrl.title}`} />

            <meta name="description" content={seoDescription} />
            <meta property="og:description" content={seoDescription} />
            <meta name="twitter:description" content={seoDescription} />

            {playlistByUrl.imgPath && (
              <>
                <meta property="og:image" content={playlistByUrl.imgPath} />
                <meta name="twitter:image" content={playlistByUrl.imgPath} />
              </>
            )}
          </Helmet>
        )}
        <div className="w-full flex flex-col justify-center items-center py-8">
          {playlistByUrl && (
            <PlaylistByUrl playlist={playlistByUrl} publicUrl={publicUrl} />
          )}
        </div>
      </>
    </div>
  );
};

export default Playlist;
